/**
 * Precio de alquiler por modelo según duración (misma lógica que bike-rental-booking
 * y bike-rental-backend/services/pricing.service.js).
 * threeToFive = porcentaje de descuento sobre el total base en reservas de 3–5 días.
 */

/**
 * @param {Object} model - Modelo con basePrice, threeToFive, additionalDay (números o coercionables)
 * @returns {{ basePrice: number, threeToFive: number, additionalDay: number } | null}
 */
export function normalizeVehicleModelPricing(model) {
  if (!model) return null;
  const basePrice = Number(model.basePrice);
  const threeToFive = Number(model.threeToFive);
  const additionalDay = Number(model.additionalDay);
  if (!Number.isFinite(basePrice) || !Number.isFinite(threeToFive) || !Number.isFinite(additionalDay)) {
    return null;
  }
  return { basePrice, threeToFive, additionalDay };
}

/**
 * Precio total del alquiler del modelo para N días (sin temporadas; el caller usa totalPrice del backend si aplica).
 * @param {{ basePrice: number, threeToFive: number, additionalDay: number }} pricing
 * @param {number} durationInDays
 */
export function calculateDynamicPrice(pricing, durationInDays) {
  if (!pricing || !durationInDays || durationInDays < 1) {
    return 0;
  }
  const { basePrice, threeToFive, additionalDay } = pricing;

  if (durationInDays <= 2) {
    return basePrice * durationInDays;
  }

  if (durationInDays >= 3 && durationInDays <= 5) {
    const baseTotal = basePrice * durationInDays;
    const discountAmount = baseTotal * (threeToFive / 100);
    return Math.round((baseTotal - discountAmount) * 100) / 100;
  }

  const first5DaysBase = basePrice * 5;
  const first5DaysDiscount = first5DaysBase * (threeToFive / 100);
  const first5DaysTotal = first5DaysBase - first5DaysDiscount;
  const additionalDays = durationInDays - 5;
  const additionalDaysTotal = additionalDay * additionalDays;

  return Math.round((first5DaysTotal + additionalDaysTotal) * 100) / 100;
}

/**
 * Precio medio por día para mostrar en catálogo (total / días).
 */
export function getAveragePricePerDay(pricing, durationInDays) {
  if (!pricing || !durationInDays || durationInDays < 1) {
    return 0;
  }
  const total = calculateDynamicPrice(pricing, durationInDays);
  return Math.round((total / durationInDays) * 100) / 100;
}
